// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3ygTj","notes":"Notes_notes__23zoH"};